import {AfterViewChecked, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageLineObj, MxButtonModel, MxPreloaderService} from 'mx-core';
import {ActivatedRoute, Router} from "@angular/router";
import {PortalMessageService} from "../../../services/portal-message.service";
import {PrlLanguageService} from "../../../../prl-language/services/prl-language.service";

@Component({
    templateUrl: './prl-message-dialog.component.html',
    standalone: false,
    styleUrls: ['./prl-message-dialog.component.scss']
})
export class PrlMessageDialogComponent implements OnInit, AfterViewChecked {
    dateTimeFormat: string = 'yyyy-MM-dd HH:mm:ss';

    backButton: MxButtonModel;
    sendButton: MxButtonModel;
    messages: Array<MessageLineObj> = [];
    isSent: boolean = false;
    isGlobal: boolean = true;
    messageForm: FormGroup;
    form: FormGroup;

    @ViewChild('scrollMe')
    private scrollContainer?: ElementRef<HTMLDivElement>;

    private pendingAutoScroll = false;

    constructor(
        private dataService: PortalMessageService,
        private route: ActivatedRoute,
        private preloader: MxPreloaderService,
        private router: Router,
        private languageService: PrlLanguageService) {}

    ngOnInit(): void {
        this.backButton = {
            icon: 'west',
            name: 'back',
            className: 'mxs-button--navigation',
            clickHandler: this.back
        };
        this.sendButton = {
            label: this.getLabel('label.send'),
            name: 'send',
            className: 'mxs-button--primary',
            disabled: this.submitDisabled,
            clickHandler: this.sendReply
        };
        this.messageForm = new FormGroup({message: new FormControl('', [Validators.maxLength(10000)])});
        this.form = new FormGroup({subject: new FormControl(), status: new FormControl(), message: new FormControl()});
        this.form.disable();
        this.dataService.getMessage(this.route.snapshot.params.id)
            .subscribe(value => {
                    this.isGlobal = value.global;
                    this.form.controls.subject.setValue(value.subject);
                    this.messages.push(...value.lines);
                    this.pendingAutoScroll = true;
                    this.preloader.hide();
                }
            );
    }

    protected submitDisabled = (): boolean => {
        const control = this.messageForm.get('message');
        return  !this.messageForm || !this.messageForm.value.message || this.isSent || control.invalid;
    };

    private back = (): void => {
        this.router.navigate(['../../'], {relativeTo: this.route});
    };

    private sendReply = (): void => {
        this.isSent = true;
        this.dataService.sendReply(this.route.snapshot.params.id, this.messageForm.value.message)
            .subscribe(_ => {this.getLastMessage();});
    };

    private getLastMessage(): void {
        this.dataService.getLastMessage(this.route.snapshot.params.id)
            .subscribe(message => {
                    this.messages.push(
                        {
                            id: message.id,
                            date: message.date,
                            message: message.text,
                            user: message.from,
                            userSend: true,
                            status: message.status
                        });
                    this.pendingAutoScroll = true;
                    this.messageForm.reset();
                    this.isSent = false;
                }
            );
    }

    getLabel = (label: string): string => {
        return this.languageService.getLabel(label);
    };

    ngAfterViewChecked(): void {
        if (this.pendingAutoScroll) {
            this.scrollToBottom();
            this.pendingAutoScroll = false;
        }
    }

    private scrollToBottom(): void {
        const container = this.scrollContainer?.nativeElement;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }
}
